'use strict';

angular.module('docketbook').
  controller('selectContactController', function(addressBookService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid) {

    // Initialise variables to be used
    $scope.contactSearch = "";
    $scope.contactSelectCallback = null;
    $scope.contactSearchList = [];
    $scope.contactSearchLoading = false;
    $scope.contactLoadingError = null;
    $scope.contactTagList = [];
    $scope.selectedContactTagFilter = {
      tags: []
    }

    $scope.loadTagList = function() {
      $scope.loadPromise = $q(function(resolve, reject) {
        addressBookService.getAddressBookTags({}, function(results){
          $scope.contactTagList = results;
          resolve($scope.contactTagList)
        }, function(err){
          $scope.contactTagList = [];
          reject('Error');
        })
      })
    }

    $scope.query = {
      limit: 10,
      page: 1,
      sort: 'displayName'
    };
    $scope.contactsSelected = [];

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.contactSelectFromParent = function(existingContacts, selectedContactPre, cb) {
      $scope.contactModalMode = 'select';
      $scope.updateContactOnSelect = false;
      $scope.contactSearch = "";
      $scope.contactSelectCallback = cb;
      if ( selectedContactPre != null ) {
        var selectedContact = angular.copy(selectedContactPre);

        var initials = "";
        if ( selectedContact.displayName ) {
          var split = selectedContact.displayName.split(' ');
          if ( split.length == 1 ) {
            initials = split[0].charAt(0).toUpperCase();
          } else if ( split.length > 1 ) {
            initials = split[0].charAt(0).toUpperCase();
            initials += split[1].charAt(0).toUpperCase();
          }
        }
        selectedContact.initials = initials;
        $scope.selectContact(selectedContact);
      } else {
        $scope.contactDetail = null;
      }
      if ( existingContacts ) {
        $scope.existingContacts = existingContacts;
      } else {
        $scope.existingContacts = [];
      }
      if ( $scope.device == 'mobile' ) {

      } else {
        $("#selectContactModal").fadeIn(100);
				$("input[name='searchContactInput']").focus();
      }
      $scope.loadTagList();
      $scope.loadContactSearchList();
    }

    $scope.$parent.updateContactFromParent = function(orgId, orgUnitId, share, cb) {
      $scope.contactModalMode = 'edit';
      $scope.contactSearch = "";
      $scope.contactDetail = null;
      $scope.existingContacts = [];
      $scope.contactCallback = cb;
      $scope.orgFor = orgId;
      $scope.orgUnitFor = orgUnitId;
      $("#selectContactModal").fadeIn(100);
			$("input[name='searchContactInput']").focus();
      $scope.loadContactSearchList();
      $scope.updateContactOnSelect = true;
      $scope.updateContactShare = share;
    }

    $scope.$parent.createContactFromParent = function(orgId, orgUnitId, share, cb) {
      $scope.contactModalMode = 'edit';
      $scope.contactCallback = cb;
      $scope.contactSearch = "";
      $scope.contactDetail = null;
      $scope.existingContacts = [];
      $scope.orgFor = orgId;
      $scope.orgUnitFor = orgUnitId;
      $("#selectContactModal").fadeIn(100);
			$("input[name='searchContactInput']").focus();
      $scope.loadContactSearchList();
      $scope.contactDetail = {};
      $scope.contactDetail.new = true;
      $scope.contactDetail.displayName = share.displayName;
      var initials = "";
			if ( $scope.contactDetail.displayName ) {
	      var split = $scope.contactDetail.displayName.split(' ');
	      if ( split.length == 1 ) {
	        initials = split[0].charAt(0).toUpperCase();
	      } else if ( split.length > 1 ) {
	        initials = split[0].charAt(0).toUpperCase();
	        initials += split[1].charAt(0).toUpperCase();
	      }
      }
      $scope.contactDetail.initials = initials;
      if ( share.addresses != null ) {
        $scope.contactDetail.addresses = share.addresses;
      } else {
        $scope.contactDetail.addresses = [];
      }
      $scope.contactDetail.contactAddresses = [];
      for ( var i = 0; i < share.contactAddresses.length; i++ ) {
        var newContact = {emailAddress:share.contactAddresses[i],accessLevel:'viewer', selected: true};
        $scope.contactDetail.contactAddresses.push(newContact);
      }
    }

    $scope.createNewContact = function() {
      $scope.contactDetail = {};
      $scope.contactDetail.newFull = true;
      $scope.contactDetail.displayName = "";
      $scope.contactDetail.initials = "";
      $scope.contactDetail.addresses = [];
      $scope.contactDetail.contactAddresses = [];
    }

    $scope.saveContactEdit = function(contact) {
      contact.loading = true;

      // If contact is not new - format addresses array in add/update/remove format
      if ( contact.id != null ) {
        var newAddresses = {'add': [], 'update': []};
        if ( contact.addresses && contact.addresses.length > 0 ) {
          if ( contact.addressesBefore && contact.addressesBefore.length > 0 ) {
            var newAddressUpdate = contact.addresses[0];
            newAddressUpdate.id = contact.addressesBefore[0].id;
            newAddresses.update.push(newAddressUpdate);
          } else {
            newAddresses.add.push(contact.addresses[0]);
          }
        }
        contact.addresses = newAddresses;
      }

      // remove any new contactAddresses that are not selected
      var contactAddressesUpdated = [];
      for ( var i = 0; i < contact.contactAddresses.length; i++ ) {
        if ( ( contact.contactAddresses[i].new == true && contact.contactAddresses[i].selected == true ) ||
                contact.contactAddresses[i].new != true ) {
          delete contact.contactAddresses[i].new;
          contactAddressesUpdated.push(contact.contactAddresses[i]);
        }
      }
      contact.contactAddresses = contactAddressesUpdated;

      if ( $scope.orgFor != null && $scope.orgUnitFor != null ) {
        addressBookService.saveContactForUnit($scope.orgFor, $scope.orgUnitFor, contact, function(success) {
          $("#selectContactModal").fadeOut(100);
          $scope.contactCallback();
        });
      } else {
        addressBookService.saveContact(contact, function(success) {
          $("#selectContactModal").fadeOut(100);
          $scope.contactCallback();
        });
      }
    }

    $scope.loadContactSearchList = function(searchValue) {
      $scope.contactSearchLoading = true;
      $scope.promise = $q(function(resolve, reject) {
        var params = {};
        params.sort = "displayName";
        if ( searchValue != null && searchValue != "" ) {
          params.search = searchValue;
        }
        const tags = $scope.selectedContactTagFilter.tags.map((tag) => {
          return tag.tag;
        });
        if ((tags) && (tags.length > 0)) {
          params.tags = tags.join(',');
        }
        addressBookService.getAddressBookForUnit(params, function(addressBookFull) {
          $scope.contactSearchList = addressBookFull;
          $scope.contactSearchListFull = angular.copy(addressBookFull);
          for ( var i = 0; i < $scope.contactSearchList.length; i++ ) {
            $scope.contactSearchList[i].existing = false;
            if ( $scope.existingContacts && $scope.existingContacts.length > 0 ) {
              for ( var j = 0; j < $scope.existingContacts.length; j++ ) {
                if ( $scope.contactSearchList[i].id == $scope.existingContacts[j].id ) {
                  $scope.contactSearchList[i].existing = true;
                  break;
                }
              }
            }

            var initials = "";
            if ( $scope.contactSearchList[i].displayName ) {
              var split = $scope.contactSearchList[i].displayName.split(' ');
              if ( split.length == 1 ) {
                initials = split[0].charAt(0).toUpperCase();
              } else if ( split.length > 1 ) {
                initials = split[0].charAt(0).toUpperCase();
                initials += split[1].charAt(0).toUpperCase();
              }
            }
            $scope.contactSearchList[i].initials = initials;
            var existingXeroContact = $scope.contactSearchList[i].externalIdentifiers.find(function(eid) {
              return eid.type === 'xero';
            });
            if ( existingXeroContact ) {
              $scope.contactSearchList[i].xeroContact = existingXeroContact;
            }
          }
          $scope.contactSearchList = Restangular.stripRestangular($scope.contactSearchList);
          $scope.contactSearchLoading = false;
          resolve('Done');
        }, function(err) {
          $scope.contactSearchLoading = false;
          $scope.contactLoadingError = "Error getting contacts";
          reject('Error');
        });
      });
    }

    $scope.selectContact = function(contact) {
      if (($scope.contactModalMode === 'edit') && (!$scope.updateContactOnSelect)) {
        return;
      }
      if ( !contact.existing ) {
        $scope.contactDetail = angular.copy(contact);
        for ( var i = 0; i < $scope.contactDetail.contactAddresses.length; i++ ) {
          $scope.contactDetail.contactAddresses[i].tempId = uuid.v4();
          $scope.contactDetail.contactAddresses[i].selected = true;
        }
        //$scope.contactDetail.address = {};
        //if ( $scope.contactDetail.addresses != null && $scope.contactDetail.addresses[0] != null ) {
          //$scope.contactDetail.address = $scope.contactDetail.addresses[0];
        //}
      }

      if ( $scope.updateContactOnSelect && $scope.updateContactShare ) {
        // add details from share into this contact
        //$scope.contactDetail.displayName = $scope.updateContactShare.displayName;
        $scope.contactDetail.addressesBefore = angular.copy($scope.contactDetail.addresses);
        if ( $scope.updateContactShare.addresses != null ) {
          $scope.contactDetail.addresses = $scope.updateContactShare.addresses;
        }
        if ( $scope.updateContactShare.contactAddresses != null ) {
          for ( var i = 0; i < $scope.updateContactShare.contactAddresses.length; i++ ) {
            var newContact = { 'emailAddress' : $scope.updateContactShare.contactAddresses[i], 'accessLevel': 'viewer', selected: true, new: true };
            $scope.contactDetail.contactAddresses.push(newContact);
          }
        }
      }
    }

    $scope.desktopSelectContactContinue = function() {
      // convert addresses back
      var contactToSend = angular.copy($scope.contactDetail);
      //contactToSend.addresses = [];
      //if ( contactToSend.address && contactToSend.address.suburb != null && contactToSend.address.state != null && contactToSend.address.postCode != null ) {
        //contactToSend.addresses.push(contactToSend.address);
      //}

      // remove contacts that aren't selected
      contactToSend.contactAddresses = [];
      for ( var i = 0; i < $scope.contactDetail.contactAddresses.length; i++ ) {
        if ( $scope.contactDetail.contactAddresses[i].selected == true ) {
          contactToSend.contactAddresses.push($scope.contactDetail.contactAddresses[i]);
        }
      }
      if (($scope.contactSelectCallback) && (typeof $scope.contactSelectCallback === 'function')) {
        $scope.contactSelectCallback(contactToSend);
      }

      $("#selectContactModal").fadeOut(100);
    }

    $scope.mobileSelectContact = function(contact) {
      //$("#viewContactModal").fadeIn(100);
      if (($scope.contactSelectCallback) && (typeof $scope.contactSelectCallback === 'function')) {
        $scope.contactSelectCallback(contact);
      }
      /*$scope.contactDetail = contact;
      $scope.contactDetail.editing = false;
      for ( var i = 0; i < $scope.contactDetail.contactAddresses.length; i++ ) {
        $scope.contactDetail.contactAddresses[i].tempId = uuid.v4();
        $scope.contactDetail.contactAddresses[i].selected = true;
      }
      $scope.contactDetail.address = {};
      if ( $scope.contactDetail.addresses != null && $scope.contactDetail.addresses[0] != null ) {
        $scope.contactDetail.address = $scope.contactDetail.addresses[0];
      }*/
    }

    $scope.mobileContactContinue = function(contact) {
      $("#viewContactModal").fadeOut(100);
      var contactToSend = $scope.contactDetail;
      contactToSend.addresses = [];
      contactToSend.addresses.push(contactToSend.address);
      if (($scope.contactSelectCallback) && (typeof $scope.contactSelectCallback === 'function')) {
        $scope.contactSelectCallback(contactToSend);
      }
    }

    $scope.closeViewContactModal = function() {
      $("#viewContactModal").fadeOut(100);
    }

    $scope.closeContactSelectList = function() {
      $("#selectContactModal").fadeOut(100);
      if (($scope.contactSelectCallback) && (typeof $scope.contactSelectCallback === 'function')) {
        $scope.contactSelectCallback(null);
      }
    }

    $scope.searchContactChange = function(searchText) {
      $scope.loadContactSearchList(searchText);
    }

    /* Mobile contact detail - edit contact */
    $scope.editContactDetails = function() {
      $scope.contactDetail.editing = true;
    }

    $scope.saveContactDetails = function() {
      $scope.contactDetail.editing = false;
    }

    /* Desktop Contact Select - Check selected contact valid */
    $scope.selectedContactIsValid = function(contactSelected) {
      var valid = false;

      if ( contactSelected && contactSelected.contactAddresses ) {
        var selectedCount = 0;
        for ( var i = 0; i < contactSelected.contactAddresses.length; i++ ) {
          if ( contactSelected.contactAddresses[i].selected ) {
            selectedCount += 1;
          }
        }
        if ( selectedCount > 0 ) {
          valid = true;
        }
      }

      return valid;
    }

});



// WEBPACK FOOTER //
// ./src/controllers/selectors/selectContactController.js